import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";
import { DashboardIcon } from "../common/Dashboard";
import { AdminNavText } from "../../sections/AdminDashboard/shared/adminUx";
import CustomerProfile from "../common/Profile/CustomerProfile";
import useCustomerSidebarData from "./CustomerSidebarData";
import { pathMatches, sectionActive } from "./customerSidebarNav";

const NavIconWrap = ({ children }) => (
  <DashboardIcon size="regular" className="text-inherit">
    {children}
  </DashboardIcon>
);

export default function CustomerSidebar() {
  const [open, setOpen] = useState(null);
  const location = useLocation();
  const pathname = location.pathname;
  const customerSidebarLink = useCustomerSidebarData();

  const toggleHandler = (index) => {
    setOpen((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    const expandedIndex = customerSidebarLink.findIndex((item) =>
      sectionActive(item, pathname)
    );
    if (expandedIndex >= 0 && customerSidebarLink[expandedIndex]?.subMenu) {
      setOpen(expandedIndex);
    }
  }, [pathname]);

  return (
    <div
      id="default-sidebar"
      className="lg:w-[200px] xl:w-[200px] 2xl:w-[200px] h-auto bg-white rounded-xl"
    >
      <CustomerProfile profileCompleteion={false} />
      <div className="overflow-y-auto text-offblack mt-5 pt-5 border-t border-t-mediumgray">
        <ul>
          <li>
            {customerSidebarLink?.map((e, index) => {
              const itemActive = sectionActive(e, pathname);

              if (e.subMenu) {
                const expanded = open === index;
                return (
                  <li key={e.linkName || index}>
                    <button
                      type="button"
                      className={
                        expanded || itemActive
                          ? "flex items-center justify-between px-0 py-3 text-primaryblue w-full"
                          : "flex items-center justify-between px-0 py-3 hover:text-primaryblue w-full"
                      }
                      aria-expanded={expanded}
                      onClick={() => toggleHandler(index)}
                    >
                      <span className="flex items-center gap-3 min-w-0">
                        <NavIconWrap>{itemActive ? e.iconSelected : e.icon}</NavIconWrap>
                        <AdminNavText
                          className={
                            expanded || itemActive
                              ? "text-primaryblue whitespace-nowrap"
                              : "text-offblack hover:text-primaryblue whitespace-nowrap"
                          }
                        >
                          {e.linkName}
                        </AdminNavText>
                      </span>
                      <i
                        className="fi fi-rs-angle-down text-sm text-offblack leading-none flex items-center shrink-0"
                        aria-hidden
                      />
                    </button>
                    {expanded && (
                      <ul className="transition duration-150 ease-in-out py-2 space-y-2 flex flex-col w-full pl-3">
                        {e.subMenu.map((sub) => (
                          <li key={sub.id}>
                            <NavHashLink
                              to={sub.link}
                              className={`flex items-center gap-3 hover:text-primaryblue w-full px-5 py-2 ${
                                pathMatches(pathname, sub.link)
                                  ? "text-primaryblue"
                                  : "text-offblack"
                              }`}
                            >
                              {sub.icon ? <NavIconWrap>{sub.icon}</NavIconWrap> : null}
                              <AdminNavText className="capitalize">{sub.linkName}</AdminNavText>
                              {typeof sub.badge !== "undefined" && (
                                <span className="inline-flex items-center justify-center rounded-full bg-alertred text-white text-[11px] min-w-5 h-5 px-1 ml-1 leading-none tabular-nums">
                                  {sub.badge}
                                </span>
                              )}
                            </NavHashLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }

              if (e.isLogout) {
                return (
                  <button
                    key={e.linkName || index}
                    type="button"
                    onClick={e.onClick}
                    className="flex items-center px-0 py-3 gap-3 text-offblack hover:text-alertred w-full transition-colors"
                  >
                    <NavIconWrap>{e.icon}</NavIconWrap>
                    <AdminNavText className="capitalize">{e.linkName}</AdminNavText>
                  </button>
                );
              }

              const linkActive = pathMatches(pathname, e.link);
              return (
                <Link
                  key={e.linkName || index}
                  to={e.link}
                  onClick={() => {
                    setOpen(null);
                    e.onClick?.();
                  }}
                  className={`flex items-center px-0 py-3 gap-3 hover:text-primaryblue ${
                    linkActive ? "text-primaryblue" : "text-offblack"
                  }`}
                >
                  <NavIconWrap>{linkActive && e.iconSelected ? e.iconSelected : e.icon}</NavIconWrap>
                  <span className="flex items-center gap-2 min-w-0">
                    <AdminNavText className="capitalize">{e.linkName}</AdminNavText>
                    {typeof e.badge !== "undefined" && (
                      <span className="inline-flex items-center justify-center rounded-full bg-alertred text-white text-[11px] min-w-5 h-5 px-1 leading-none tabular-nums">
                        {e.badge}
                      </span>
                    )}
                  </span>
                </Link>
              );
            })}
          </li>
        </ul>
      </div>
    </div>
  );
}
